import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  getOfferDocument,
  getOfferDocumentFailed,
  getOfferDocumentSucceeded,
} from "./offerAcceptSlice";

import { Uri } from "Constants/constants";
import { CartEntity } from "Store/cart/cartInterfaces";
import { ReduxState } from "Store/rootReducer";
import { CART_RESOURCE_ROOT } from "Utils/apiUtils";
import { createRequest } from "Utils/requestUtils";
import { OfferAcceptDocumentResponse } from "./offerAcceptInterfaces";

const cartSelector = (state: ReduxState): CartEntity => state.cart;

export function* fetchOfferDocument(): any {
  const cart: CartEntity = yield select(cartSelector);
  try {
    const { data } = yield call(createRequest, {
      method: "get",
      url: `${CART_RESOURCE_ROOT}/${cart.current?.cartId}/${Uri.ADVICE_DOCUMENT}`,
      open: false,
    });
    yield put(getOfferDocumentSucceeded(data as OfferAcceptDocumentResponse));
  } catch (e) {
    yield put(getOfferDocumentFailed("Failed to get offer document."));
  }
}

export function* offerAcceptSaga(): Generator {
  yield takeLatest(getOfferDocument, fetchOfferDocument);
}
